// TODO: Refactor enum values (do not use 0 as one of the values)
export enum OrderBy {
    creationTimeAsc = 0,
    creationTimeDesc = 1,
    // threadSizeAsc = 2,
    // threadSizeDesc = 3,
    lastThreadActivityAsc = 4,
    lastThreadActivityDesc = 5,
    importanceAsc = 6,
    importanceDesc = 7,
    lastAnyActivityAsc = 8,
    lastAnyActivityDesc = 9,
    expirationTimeAsc = 10,
}
